import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {JobRequestReport} from 'src/app/shared/Models/JobRequestReport'
import {JobService} from 'src/app/shared/API-Service/services/job.service'
@Component({
  selector: 'app-job-request-report',
  templateUrl: './job-request-report.component.html',
  styleUrls: ['./job-request-report.component.css']
})
export class JobRequestReportComponent  {
  ReportsInfo = new JobRequestReport()
  ReceiptBooks: any;
  ReceiptStatus: any;
  currentUser: any;
  jobs: any;
  
  constructor(private router: Router,private JobService:JobService) {
  
  }

  ngOnInit(): void {
    this.GetJob();
  }
  GetJob(){
    this.JobService.GetJob().subscribe(res=>{
      this.jobs=res.data
    })
  }
  SelectJob(event){
    this.ReportsInfo.jobId = parseInt(event) 
    this.ReportsInfo.jobTitle = this.jobs.find(x => x.id == event).title
  
   }

  Viewreports() {
  
    localStorage["ReportName"] = "JobRequestReport";
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));

    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }

 }
